module.exports = __webpack_public_path__ + "img/p_sz_19.b39a518a.png";